import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect } from 'react';
import AboutUsSection from './components/AboutUsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import Navbar from './components/Navbar';
import TestimonialsSection from './components/TestimonialsSection';
import { darkTheme } from './theme/theme';

function App() {
  useEffect(() => {
    const handleInitialHash = () => {
      const hash = window.location.pathname;

      if (hash) {
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId?.toLocaleLowerCase());
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    handleInitialHash();
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          overflow: 'hidden',
        }}
      >
        <Navbar />

        <main>
          <HeroSection />
          <FeaturesSection />
          <AboutUsSection />
          <TestimonialsSection />
          <ContactSection />
        </main>

        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
